<p-button
  (onClick)="emitClick($event)"
  [disabled]="disabled()"
  [link]="link()"
  [label]="label()"
  [severity]="severity()"
  [variant]="variant()"
  [type]="actionType()"
  [fluid]="fullSize()"
  [styleClass]="buttonClass()"
/>
